import { render } from "./ElementUI.vue?vue&type=template&id=e666f170"
import script from "./ElementUI.vue?vue&type=script&lang=ts"
export * from "./ElementUI.vue?vue&type=script&lang=ts"

import "./ElementUI.vue?vue&type=style&index=0&id=e666f170&lang=scss"
script.render = render

export default script